import React from 'react';
import { connect } from 'react-redux';
import TransferOutCard from './TransferOutCard';
import TransferInCard from './TransferInCard';
import '../src/apartmentTransfer.scss';
import actions from "../actions";

const mapDispatchToProps = dispatch => ({
  fetchGivenKeys: (keys) => dispatch(actions.fetchGivenKeys(keys)),
  fetchReceivedKeys: (keys) => dispatch(actions.fetchReceivedKeys(keys)),
  fetchLostKeys: (keys) => dispatch(actions.fetchLostKeys(keys)),
  fetchBrokenKeys: (keys) => dispatch(actions.fetchBrokenKeys(keys)),
  fetchAbloyKeys: (leaseId) => dispatch(actions.fetchAbloyKeys(leaseId)),
  transferReady: (transferId) => dispatch(actions.transferReady(transferId)),
});

class ApartmentTransfer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      title: 'Muuttopäivätyökalu',
      redirect: false,
      oldLeaseInited: false,
      newLeaseInited: false,
    }
  }

  componentDidMount() {
    this.props.fetchGivenKeys(this.props.transfer.given_keys);
    this.props.fetchReceivedKeys(this.props.transfer.received_keys);
    this.props.fetchLostKeys(this.props.transfer.lost_keys);
    this.props.fetchBrokenKeys(this.props.transfer.broken_keys);

    const oldLeaseId = this.props.transfer.old_lease_id;
    const newLeaseId = this.props.transfer.new_lease_id;
    if (oldLeaseId) {
      this.props.fetchAbloyKeys(oldLeaseId).then(() => {
        this.setState({oldLeaseInited: true})
      })
    } else {
      this.setState({oldLeaseInited: true})
    }
    if (newLeaseId) {
      this.props.fetchAbloyKeys(newLeaseId).then(() => {
        this.setState({newLeaseInited: true})
      })
    } else {
      this.setState({newLeaseInited: true})
    }
  }

  street() {
    return this.props.transfer.apartment ? this.props.transfer.apartment.short_address || '' : ''
  }

  transferOut() {
    let inited = this.state.newLeaseInited && this.state.oldLeaseInited
    if (this.props.transfer.old_lease_id) {
      return <TransferOutCard transfer={this.props.transfer} inited={inited}></TransferOutCard>
    } else {
      return <div className="card-transfer"></div>
    }
  }

  transferIn() {
    let inited = this.state.newLeaseInited && this.state.oldLeaseInited
    if (this.props.transfer.new_lease_id) {
      return <TransferInCard transfer={this.props.transfer} inited={inited} ></TransferInCard>
    }
  }

  close() {
    this.setState({ redirect: true });
    const transferId = this.props.transfer.id;
    this.props.transferReady(transferId)
      .then((response)=>{
        document.getElementsByTagName('flash-messages')[0].innerHTML = ""
        window.location.href = window.location.origin + '/admin/transfers';
      }).catch(err => {
        // Handle error
        var error_message = err.response.data.error
        var flash = `<div class='flash-message error'> ${error_message} </div>`
        document.getElementsByTagName('flash-messages')[0].innerHTML = flash
    });
  }

  /*renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to='/admin/transfers' />
    }
  }*/

  render() {
    if (!this.props.transfer) {
      return null;
    }
    return (
      <div className="transfer-card-details">
        {this.transferOut()}
        {this.transferIn()}
      </div>
    );
  }
}

export default connect(undefined, mapDispatchToProps)(ApartmentTransfer)
